import React, { useEffect, useMemo, useState, useRef, Fragment } from 'react';
import { Shield, Search, AlertTriangle, CheckCircle2, Clock, Filter, Download, Plus, Edit2, Play, FileText, X, Eye, EyeOff, AlertCircle } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// --- MOCK DATA ---
const generateTrendData = () => {
  const data = [];
  const today = new Date();
  for (let i = 30; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    data.push({
      date: date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: 'short'
      }),
      Bloccate: Math.floor(Math.random() * 15) + 5,
      Mascherate: Math.floor(Math.random() * 25) + 10,
      Loggate: Math.floor(Math.random() * 40) + 20
    });
  }
  return data;
};
const TREND_DATA = generateTrendData();
const LOGS_DATA = [{
  id: 'l1',
  timestamp: '27 Mar 2026, 14:32',
  service: 'Customer Assistant',
  dataType: 'Codice Fiscale',
  action: 'Bloccata',
  severity: 'Critico'
}, {
  id: 'l2',
  timestamp: '27 Mar 2026, 14:15',
  service: 'Smart Matcher',
  dataType: 'Email',
  action: 'Mascherata',
  severity: 'Warning'
}, {
  id: 'l3',
  timestamp: '27 Mar 2026, 13:45',
  service: 'Resume Screener',
  dataType: 'Dati Sanitari',
  action: 'Bloccata',
  severity: 'Critico'
}, {
  id: 'l4',
  timestamp: '27 Mar 2026, 12:30',
  service: 'Content Moderator',
  dataType: 'Nome/Cognome',
  action: 'Log Only',
  severity: 'Info'
}, {
  id: 'l5',
  timestamp: '27 Mar 2026, 11:20',
  service: 'Customer Assistant',
  dataType: 'IBAN',
  action: 'Mascherata',
  severity: 'Warning'
}, {
  id: 'l6',
  timestamp: '27 Mar 2026, 10:05',
  service: 'Document Analyzer',
  dataType: 'Numero Telefono',
  action: 'Log Only',
  severity: 'Info'
}, {
  id: 'l7',
  timestamp: '26 Mar 2026, 16:40',
  service: 'AI Tutor',
  dataType: 'Email',
  action: 'Mascherata',
  severity: 'Warning'
}, {
  id: 'l8',
  timestamp: '26 Mar 2026, 15:10',
  service: 'Resume Screener',
  dataType: 'Dati Biometrici',
  action: 'Bloccata',
  severity: 'Critico'
}, {
  id: 'l9',
  timestamp: '26 Mar 2026, 14:00',
  service: 'Smart Matcher',
  dataType: 'Indirizzo',
  action: 'Log Only',
  severity: 'Info'
}, {
  id: 'l10',
  timestamp: '26 Mar 2026, 11:45',
  service: 'Customer Assistant',
  dataType: 'Codice Fiscale',
  action: 'Bloccata',
  severity: 'Critico'
}];
const SCANS_DATA = [{
  id: 'sc1',
  service: 'Customer Assistant',
  date: '26 Mar 2026',
  high: 0,
  medium: 2,
  low: 5,
  status: 'Completata'
}, {
  id: 'sc2',
  service: 'Resume Screener',
  date: '25 Mar 2026',
  high: 1,
  medium: 4,
  low: 12,
  status: 'Da risolvere'
}, {
  id: 'sc3',
  service: 'Smart Matcher',
  date: '20 Mar 2026',
  high: 0,
  medium: 0,
  low: 3,
  status: 'Completata'
}, {
  id: 'sc4',
  service: 'Document Analyzer',
  date: '18 Mar 2026',
  high: 2,
  medium: 5,
  low: 8,
  status: 'Da risolvere'
}, {
  id: 'sc5',
  service: 'Content Moderator',
  date: '15 Mar 2026',
  high: 0,
  medium: 1,
  low: 4,
  status: 'Completata'
}, {
  id: 'sc6',
  service: 'AI Tutor',
  date: '10 Mar 2026',
  high: 0,
  medium: 0,
  low: 1,
  status: 'Completata'
}];
const DPO_DATA = [{
  id: 'd1',
  service: 'Customer Assistant',
  dpo: 'Dr. Laura Bianchi',
  contact: 'Mario Rossi',
  controller: 'SIAE SpA',
  updated: '15 Gen 2026'
}, {
  id: 'd2',
  service: 'Smart Matcher',
  dpo: 'Avv. Marco Conti',
  contact: 'Giulia Verdi',
  controller: 'SIAE SpA',
  updated: '20 Feb 2026'
}, {
  id: 'd3',
  service: 'Content Moderator',
  dpo: 'Dr. Laura Bianchi',
  contact: 'Luca Neri',
  controller: 'SIAE SpA',
  updated: '10 Mar 2026'
}, {
  id: 'd4',
  service: 'AI Tutor',
  dpo: 'Avv. Elena Ferrari',
  contact: 'Sofia Romano',
  controller: 'SIAE SpA',
  updated: '05 Mar 2026'
}, {
  id: 'd5',
  service: 'Resume Screener',
  dpo: 'Avv. Marco Conti',
  contact: 'Andrea Costa',
  controller: 'HR Dept',
  updated: '28 Feb 2026'
}, {
  id: 'd6',
  service: 'Document Analyzer',
  dpo: 'Dr. Laura Bianchi',
  contact: 'Elena Gallo',
  controller: 'Legal Dept',
  updated: '12 Gen 2026'
}];
const DATA_TYPES_DATA = [{
  id: 'dt1',
  name: 'Codice Fiscale',
  pattern: '^[A-Z]{6}\\d{2}[A-Z]\\d{2}[A-Z]\\d{3}[A-Z]$',
  severity: 'Alta',
  action: 'Blocca',
  services: 8,
  active: true
}, {
  id: 'dt2',
  name: 'IBAN',
  pattern: '^IT\\d{2}[A-Z]\\d{22}$',
  severity: 'Alta',
  action: 'Blocca',
  services: 5,
  active: true
}, {
  id: 'dt3',
  name: 'Email',
  pattern: '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$',
  severity: 'Media',
  action: 'Maschera',
  services: 12,
  active: true
}, {
  id: 'dt4',
  name: 'Numero Telefono',
  pattern: '^\\+?\\d{10,13}$',
  severity: 'Bassa',
  action: 'Solo Log',
  services: 10,
  active: true
}, {
  id: 'dt5',
  name: 'Dati Sanitari',
  pattern: '(diagnosi|patologia|ricovero|terapia)',
  severity: 'Alta',
  action: 'Blocca',
  services: 2,
  active: true
}, {
  id: 'dt6',
  name: 'Dati Biometrici',
  pattern: '(impronta|volto|iride|voce)',
  severity: 'Alta',
  action: 'Blocca',
  services: 1,
  active: true
}, {
  id: 'dt7',
  name: 'Indirizzo',
  pattern: '(via|piazza|viale|corso)\\s+[a-zA-Z\\s]+,\\s*\\d+',
  severity: 'Media',
  action: 'Maschera',
  services: 6,
  active: false
}, {
  id: 'dt8',
  name: 'Nome/Cognome',
  pattern: '^[A-Z][a-z]+\\s[A-Z][a-z]+$',
  severity: 'Bassa',
  action: 'Solo Log',
  services: 12,
  active: true
}];
// --- COMPONENTS ---
export function GDPRPage() {
  const [activeTab, setActiveTab] = useState('Monitoraggio');
  const [period, setPeriod] = useState('30G');
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Modal Form State
  const [newTypeName, setNewTypeName] = useState('');
  const [newTypePattern, setNewTypePattern] = useState('');
  const [newTypeSeverity, setNewTypeSeverity] = useState('Media');
  const [newTypeAction, setNewTypeAction] = useState('Maschera');
  const [newTypeDesc, setNewTypeDesc] = useState('');
  // Scan simulation state
  const [isScanning, setIsScanning] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
  const [scanComplete, setScanComplete] = useState(false);
  const [selectedRepo, setSelectedRepo] = useState('Customer Assistant (repo: cust-assist-ai)');
  const scanIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const SCAN_RESULTS = {
    service: 'Customer Assistant',
    date: new Date().toLocaleDateString('it-IT', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }),
    duration: '2m 34s',
    filesScanned: 147,
    high: 1,
    medium: 3,
    low: 5,
    findings: [{
      severity: 'Alta',
      file: 'src/handlers/userQuery.ts',
      line: 87,
      desc: 'Dati utente (email, nome) inviati al provider LLM senza anonimizzazione preventiva.',
      rule: 'GDPR Art. 25 - Data Protection by Design'
    }, {
      severity: 'Media',
      file: 'src/services/contextBuilder.ts',
      line: 203,
      desc: 'Il contesto della conversazione include lo storico completo senza limite temporale di retention.',
      rule: 'GDPR Art. 5(1)(e) - Limitazione della conservazione'
    }, {
      severity: 'Media',
      file: 'src/middleware/logging.ts',
      line: 45,
      desc: 'I log delle richieste contengono payload completi con possibili dati personali in chiaro.',
      rule: 'GDPR Art. 32 - Sicurezza del trattamento'
    }, {
      severity: 'Media',
      file: 'src/utils/exportData.ts',
      line: 112,
      desc: 'Funzione di export CSV non applica filtri sui campi sensibili prima del download.',
      rule: 'GDPR Art. 5(1)(f) - Integrità e riservatezza'
    }, {
      severity: 'Bassa',
      file: 'src/config/providers.ts',
      line: 23,
      desc: 'Manca documentazione esplicita sulla base giuridica del trattamento per ciascun provider.',
      rule: 'GDPR Art. 6 - Liceità del trattamento'
    }, {
      severity: 'Bassa',
      file: 'src/components/ChatWidget.tsx',
      line: 156,
      desc: 'Il banner di consenso non specifica le finalità di trattamento AI in modo granulare.',
      rule: 'GDPR Art. 7 - Condizioni per il consenso'
    }, {
      severity: 'Bassa',
      file: 'src/services/analytics.ts',
      line: 78,
      desc: 'Metriche di utilizzo aggregate includono user-agent e IP senza pseudonimizzazione.',
      rule: 'GDPR Art. 4(5) - Pseudonimizzazione'
    }, {
      severity: 'Bassa',
      file: 'src/api/feedback.ts',
      line: 34,
      desc: 'Endpoint di feedback non implementa il diritto alla cancellazione dei commenti utente.',
      rule: 'GDPR Art. 17 - Diritto alla cancellazione'
    }, {
      severity: 'Bassa',
      file: 'src/hooks/useUserProfile.ts',
      line: 91,
      desc: 'Profilo utente caricato senza verifica del consenso aggiornato al trattamento.',
      rule: 'GDPR Art. 7(3) - Revoca del consenso'
    }]
  };
  const startScan = () => {
    setIsScanning(true);
    setScanProgress(0);
    setScanComplete(false);
    scanIntervalRef.current = setInterval(() => {
      setScanProgress(prev => {
        if (prev >= 100) {
          if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
          setIsScanning(false);
          setScanComplete(true);
          return 100;
        }
        // Variable speed: slower at start and end, faster in middle
        const increment = prev < 20 ? 2 : prev < 80 ? 4 : 2;
        return Math.min(prev + increment, 100);
      });
    }, 150);
  };
  // Cleanup interval on unmount
  useEffect(() => {
    return () => {
      if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
    };
  }, []);
  const filteredLogs = useMemo(() => {
    return LOGS_DATA.filter(l => l.service.toLowerCase().includes(searchQuery.toLowerCase()) || l.dataType.toLowerCase().includes(searchQuery.toLowerCase()));
  }, [searchQuery]);
  const getSeverityBadge = (severity: string) => {
    switch (severity) {
      case 'Critico':
      case 'Alta':
        return <span className="bg-red-50 text-red-600 border border-red-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium" data-id="element-2673">
            Critico
          </span>;
      case 'Warning':
      case 'Media':
        return <span className="bg-amber-50 text-amber-600 border border-amber-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium" data-id="element-2674">
            Warning
          </span>;
      case 'Info':
      case 'Bassa':
        return <span className="bg-blue-50 text-blue-600 border border-blue-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium" data-id="element-2675">
            Info
          </span>;
      default:
        return null;
    }
  };
  const getActionBadge = (action: string) => {
    switch (action) {
      case 'Bloccata':
      case 'Blocca':
        return <span className="bg-red-50 text-red-600 border border-red-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2676">
            <Shield className="w-3 h-3" data-id="element-2677" /> Blocca
          </span>;
      case 'Mascherata':
      case 'Maschera':
        return <span className="bg-amber-50 text-amber-600 border border-amber-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2678">
            <EyeOff className="w-3 h-3" data-id="element-2679" /> Maschera
          </span>;
      case 'Log Only':
      case 'Solo Log':
        return <span className="bg-blue-50 text-blue-600 border border-blue-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2680">
            <FileText className="w-3 h-3" data-id="element-2681" /> Solo Log
          </span>;
      default:
        return null;
    }
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Completata':
        return <span className="bg-emerald-50 text-emerald-600 border border-emerald-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2682">
            <CheckCircle2 className="w-3 h-3" data-id="element-2683" /> Completata
          </span>;
      case 'In corso':
        return <span className="bg-blue-50 text-blue-600 border border-blue-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2684">
            <Clock className="w-3 h-3" data-id="element-2685" /> In corso
          </span>;
      case 'Da risolvere':
        return <span className="bg-amber-50 text-amber-600 border border-amber-100 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1" data-id="element-2686">
            <AlertTriangle className="w-3 h-3" data-id="element-2687" /> Da risolvere
          </span>;
      default:
        return null;
    }
  };
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8 relative" data-id="element-2688">
      {/* 1. HEADER */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-2689">
        <div data-id="element-2690">
          <h1 className="text-[28px] md:text-[32px] font-semibold text-[#1A202C] tracking-tight" data-id="element-2691">
            GDPR Compliance
          </h1>
        </div>
        <div className="flex items-center bg-white border border-gray-200 rounded-lg p-1 shadow-sm" data-id="element-2692">
          {['7G', '30G', '90G', '12M'].map(p => <button key={p} onClick={() => setPeriod(p)} className={`px-3 py-1.5 text-[12px] font-medium rounded-md transition-colors ${period === p ? 'bg-[#F4F6F8] text-[#2A3B5C] shadow-sm' : 'text-gray-500 hover:text-[#1A202C]'}`} data-id="element-2693">
              {p}
            </button>)}
        </div>
      </div>

      {/* 2. TABS NAVIGATION */}
      <div className="border-b-2 border-gray-300 mb-8" data-id="element-2694">
        <div className="-mb-[2px] flex items-center gap-8 overflow-x-auto custom-scrollbar" data-id="element-2695">
          {['Monitoraggio', 'Scansione Repository', 'DPO & Responsabili', 'Dati Sensibili'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-[15px] font-medium transition-colors whitespace-nowrap border-b-2 ${activeTab === tab ? 'border-[#00B4D8] text-[#2A3B5C]' : 'border-transparent text-gray-500 hover:text-gray-800'}`} data-id="element-2696">
              {tab}
            </button>)}
        </div>
      </div>

      {/* 3. TAB CONTENT */}

      {/* TAB 1: MONITORAGGIO */}
      {activeTab === 'Monitoraggio' && <div className="space-y-6" data-id="element-2697">
          {/* Area Chart */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6" data-id="element-2698">
            <div className="flex justify-between items-center mb-6" data-id="element-2699">
              <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2700">
                Trend Intercettazioni Dati Sensibili
              </h2>
              <div className="flex items-center gap-4 text-[11px] font-medium" data-id="element-2701">
                <div className="flex items-center gap-1.5" data-id="element-2702">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-500" data-id="element-2703"></div>
                  Bloccate
                </div>
                <div className="flex items-center gap-1.5" data-id="element-2704">
                  <div className="w-2.5 h-2.5 rounded-full bg-amber-500" data-id="element-2705"></div>
                  Mascherate
                </div>
                <div className="flex items-center gap-1.5" data-id="element-2706">
                  <div className="w-2.5 h-2.5 rounded-full bg-blue-500" data-id="element-2707"></div>
                  Loggate
                </div>
              </div>
            </div>
            <div className="h-[280px] w-full" data-id="element-2708">
              <ResponsiveContainer width="100%" height="100%" data-id="element-2709">
                <AreaChart data={TREND_DATA} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-2710">
                  <defs data-id="element-2711">
                    <linearGradient id="colorBloccate" x1="0" y1="0" x2="0" y2="1" data-id="element-2712">
                      <stop offset="5%" stopColor="#ef4444" stopOpacity={0.3} data-id="element-2713" />
                      <stop offset="95%" stopColor="#ef4444" stopOpacity={0} data-id="element-2714" />
                    </linearGradient>
                    <linearGradient id="colorMascherate" x1="0" y1="0" x2="0" y2="1" data-id="element-2715">
                      <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.3} data-id="element-2716" />
                      <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} data-id="element-2717" />
                    </linearGradient>
                    <linearGradient id="colorLoggate" x1="0" y1="0" x2="0" y2="1" data-id="element-2718">
                      <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} data-id="element-2719" />
                      <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} data-id="element-2720" />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2721" />
                  <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6B7280'
              }} dy={10} minTickGap={30} data-id="element-2722" />
                  <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 11,
                fill: '#6B7280'
              }} data-id="element-2723" />
                  <Tooltip contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #E5E7EB',
                fontSize: '12px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} itemStyle={{
                color: '#1A202C',
                fontWeight: 500
              }} data-id="element-2724" />
                  <Area type="monotone" dataKey="Loggate" stackId="1" stroke="#3b82f6" fill="url(#colorLoggate)" strokeWidth={2} data-id="element-2725" />
                  <Area type="monotone" dataKey="Mascherate" stackId="1" stroke="#f59e0b" fill="url(#colorMascherate)" strokeWidth={2} data-id="element-2726" />
                  <Area type="monotone" dataKey="Bloccate" stackId="1" stroke="#ef4444" fill="url(#colorBloccate)" strokeWidth={2} data-id="element-2727" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Logs Table */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col" data-id="element-2728">
            <div className="p-4 border-b border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-2729">
              <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2730">
                Log Intercettazioni
              </h2>
              <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-2731">
                <div className="relative w-full sm:w-64" data-id="element-2732">
                  <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-2733" />
                  <input type="text" placeholder="Cerca servizio o tipo dato..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-9 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8] transition-all" data-id="element-2734" />
                </div>
                <button className="p-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-500 hover:text-[#1A202C] hover:bg-gray-100 transition-colors" data-id="element-2735">
                  <Filter className="w-4 h-4" data-id="element-2736" />
                </button>
                <button className="p-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-500 hover:text-[#1A202C] hover:bg-gray-100 transition-colors" data-id="element-2737">
                  <Download className="w-4 h-4" data-id="element-2738" />
                </button>
              </div>
            </div>
            <div className="overflow-x-auto" data-id="element-2739">
              <table className="w-full text-left border-collapse" data-id="element-2740">
                <thead data-id="element-2741">
                  <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-2742">
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2743">
                      Timestamp
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2744">
                      Servizio
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2745">
                      Tipo Dato
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2746">
                      Azione
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2747">
                      Severità
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-2748">
                  {filteredLogs.map(log => <tr key={log.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-2749">
                      <td className="px-6 py-4" data-id="element-2750">
                        <span className="text-[13px] text-gray-500" data-id="element-2751">
                          {log.timestamp}
                        </span>
                      </td>
                      <td className="px-6 py-4" data-id="element-2752">
                        <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2753">
                          {log.service}
                        </span>
                      </td>
                      <td className="px-6 py-4" data-id="element-2754">
                        <span className="text-[13px] text-[#1A202C]" data-id="element-2755">
                          {log.dataType}
                        </span>
                      </td>
                      <td className="px-6 py-4" data-id="element-2756">
                        {getActionBadge(log.action)}
                      </td>
                      <td className="px-6 py-4" data-id="element-2757">
                        {getSeverityBadge(log.severity)}
                      </td>
                    </tr>)}
                  {filteredLogs.length === 0 && <tr data-id="element-2758">
                      <td colSpan={5} className="px-6 py-8 text-center text-[13px] text-gray-500" data-id="element-2759">
                        Nessun log trovato per "{searchQuery}"
                      </td>
                    </tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>}

      {/* TAB 2: SCANSIONE REPOSITORY */}
      {activeTab === 'Scansione Repository' && <div className="space-y-6" data-id="element-2760">
          {/* Top Actions */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-2761">
            <div className="flex-1 w-full" data-id="element-2762">
              <label className="block text-[11px] font-medium text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-2763">
                Seleziona Repository / Servizio
              </label>
              <select value={selectedRepo} onChange={e => setSelectedRepo(e.target.value)} disabled={isScanning} className="w-full sm:w-96 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-[13px] text-[#1A202C] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8] disabled:opacity-50" data-id="element-2764">
                <option data-id="element-2765">Customer Assistant (repo: cust-assist-ai)</option>
                <option data-id="element-2766">Smart Matcher (repo: smart-matcher-core)</option>
                <option data-id="element-2767">Content Moderator (repo: content-mod-v2)</option>
                <option data-id="element-2768">AI Tutor (repo: ai-tutor-platform)</option>
                <option data-id="element-2769">Resume Screener (repo: resume-screen-v3)</option>
                <option data-id="element-2770">Document Analyzer (repo: doc-analyzer)</option>
              </select>
            </div>
            <button onClick={startScan} disabled={isScanning} className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 bg-[#2A3B5C] text-white rounded-lg hover:bg-[#1E2A40] transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2771">
              <Play className="w-4 h-4" data-id="element-2772" />
              <span className="text-[14px] font-medium" data-id="element-2773">
                {isScanning ? 'Scansione in corso...' : 'Avvia Scansione'}
              </span>
            </button>
          </div>

          {/* Scan in Progress */}
          {isScanning && <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 shadow-sm" data-id="element-2774">
              <div className="flex justify-between items-center mb-4" data-id="element-2775">
                <div className="flex items-center gap-3" data-id="element-2776">
                  <div className="p-2 bg-blue-100 rounded-lg" data-id="element-2777">
                    <Search className="w-5 h-5 text-blue-600 animate-pulse" data-id="element-2778" />
                  </div>
                  <div data-id="element-2779">
                    <h3 className="text-[15px] font-semibold text-blue-900" data-id="element-2780">
                      Scansione in corso: {selectedRepo.split(' (')[0]}
                    </h3>
                    <p className="text-[12px] text-blue-700 mt-0.5" data-id="element-2781">
                      {scanProgress < 30 ? 'Analisi struttura del progetto e dipendenze...' : scanProgress < 60 ? 'Scansione codice sorgente per pattern di dati sensibili...' : scanProgress < 85 ? 'Verifica best practice GDPR e compliance...' : 'Generazione report e classificazione findings...'}
                    </p>
                  </div>
                </div>
                <span className="text-[14px] font-bold text-blue-700" data-id="element-2782">
                  {scanProgress}%
                </span>
              </div>
              <div className="w-full bg-blue-200/50 rounded-full h-2" data-id="element-2783">
                <div className="bg-blue-600 h-2 rounded-full transition-all duration-200 ease-out" style={{
            width: `${scanProgress}%`
          }} data-id="element-2784"></div>
              </div>
              <div className="flex items-center gap-4 mt-3 text-[11px] text-blue-600" data-id="element-2785">
                <span data-id="element-2786">
                  File analizzati: {Math.floor(scanProgress * 1.47)}/147
                </span>
                <span data-id="element-2787">•</span>
                <span data-id="element-2788">Tempo trascorso: {Math.floor(scanProgress * 0.15)}s</span>
              </div>
            </div>}

          {/* Scan Complete - Results */}
          {scanComplete && <div className="space-y-4" data-id="element-2789">
              {/* Summary Card */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6" data-id="element-2790">
                <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-6" data-id="element-2791">
                  <div className="flex items-center gap-3" data-id="element-2792">
                    <div className="p-2 bg-emerald-100 rounded-lg" data-id="element-2793">
                      <CheckCircle2 className="w-5 h-5 text-emerald-600" data-id="element-2794" />
                    </div>
                    <div data-id="element-2795">
                      <h3 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2796">
                        Scansione completata: {selectedRepo.split(' (')[0]}
                      </h3>
                      <p className="text-[12px] text-gray-500 mt-0.5" data-id="element-2797">
                        {SCAN_RESULTS.date} • Durata: {SCAN_RESULTS.duration} •{' '}
                        {SCAN_RESULTS.filesScanned} file analizzati
                      </p>
                    </div>
                  </div>
                  <button className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-[13px] font-medium" data-id="element-2798">
                    <Download className="w-4 h-4" data-id="element-2799" />
                    Esporta Report
                  </button>
                </div>

                {/* Severity Summary */}
                <div className="grid grid-cols-3 gap-4" data-id="element-2800">
                  <div className="bg-red-50 border border-red-100 rounded-lg p-4 text-center" data-id="element-2801">
                    <p className="text-[28px] font-bold text-red-600" data-id="element-2802">
                      {SCAN_RESULTS.high}
                    </p>
                    <p className="text-[12px] font-medium text-red-700 mt-1" data-id="element-2803">
                      Criticità Alta
                    </p>
                  </div>
                  <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 text-center" data-id="element-2804">
                    <p className="text-[28px] font-bold text-amber-600" data-id="element-2805">
                      {SCAN_RESULTS.medium}
                    </p>
                    <p className="text-[12px] font-medium text-amber-700 mt-1" data-id="element-2806">
                      Criticità Media
                    </p>
                  </div>
                  <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 text-center" data-id="element-2807">
                    <p className="text-[28px] font-bold text-blue-600" data-id="element-2808">
                      {SCAN_RESULTS.low}
                    </p>
                    <p className="text-[12px] font-medium text-blue-700 mt-1" data-id="element-2809">
                      Criticità Bassa
                    </p>
                  </div>
                </div>
              </div>

              {/* Findings Detail */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2810">
                <div className="px-6 py-5 border-b border-gray-100" data-id="element-2811">
                  <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2812">
                    Dettaglio Findings ({SCAN_RESULTS.findings.length})
                  </h2>
                </div>
                <div className="divide-y divide-gray-100" data-id="element-2813">
                  {SCAN_RESULTS.findings.map((finding, idx) => {
              const iconBg = finding.severity === 'Alta' ? 'bg-red-50 border-red-100' : finding.severity === 'Media' ? 'bg-amber-50 border-amber-100' : 'bg-blue-50 border-blue-100';
              const badgeClass = finding.severity === 'Alta' ? 'bg-red-50 text-red-600 border-red-100' : finding.severity === 'Media' ? 'bg-amber-50 text-amber-600 border-amber-100' : 'bg-blue-50 text-blue-600 border-blue-100';
              const iconColor = finding.severity === 'Alta' ? 'text-red-500' : finding.severity === 'Media' ? 'text-amber-500' : 'text-blue-500';
              return <div key={idx} className="px-6 py-4 hover:bg-gray-50/50 transition-colors" data-id="element-2814">
                        <div className="flex items-start gap-4" data-id="element-2815">
                          <div className={`mt-0.5 p-1.5 rounded-md border shrink-0 ${iconBg}`} data-id="element-2816">
                            {finding.severity === 'Alta' ? <AlertTriangle className={`w-4 h-4 ${iconColor}`} data-id="element-2817" /> : finding.severity === 'Media' ? <AlertCircle className={`w-4 h-4 ${iconColor}`} data-id="element-2818" /> : <FileText className={`w-4 h-4 ${iconColor}`} data-id="element-2819" />}
                          </div>
                          <div className="flex-1 min-w-0" data-id="element-2820">
                            <div className="flex items-center gap-3 mb-1 flex-wrap" data-id="element-2821">
                              <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide border ${badgeClass}`} data-id="element-2822">
                                {finding.severity}
                              </span>
                              <code className="text-[12px] bg-gray-100 text-gray-700 px-2 py-0.5 rounded font-mono border border-gray-200" data-id="element-2823">
                                {finding.file}{' '}
                                <span className="text-gray-400" data-id="element-2824">
                                  :{finding.line}
                                </span>
                              </code>
                            </div>
                            <p className="text-[13px] text-[#1A202C] mt-1.5" data-id="element-2825">
                              {finding.desc}
                            </p>
                            <p className="text-[11px] text-gray-500 mt-1 flex items-center gap-1" data-id="element-2826">
                              <Shield className="w-3 h-3" data-id="element-2827" /> {finding.rule}
                            </p>
                          </div>
                        </div>
                      </div>;
            })}
                </div>
              </div>
            </div>}

          {/* Scans Table - always visible */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2828">
            <div className="px-6 py-5 border-b border-gray-100" data-id="element-2829">
              <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2830">
                Storico Scansioni
              </h2>
            </div>
            <div className="overflow-x-auto" data-id="element-2831">
              <table className="w-full text-left border-collapse" data-id="element-2832">
                <thead data-id="element-2833">
                  <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-2834">
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2835">
                      Servizio
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2836">
                      Data Scansione
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-center" data-id="element-2837">
                      Criticità Alta
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-center" data-id="element-2838">
                      Criticità Media
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-center" data-id="element-2839">
                      Criticità Bassa
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2840">
                      Stato
                    </th>
                    <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2841">
                      Azioni
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-2842">
                  {SCANS_DATA.map(scan => <Fragment key={scan.id} data-id="element-2843">
                      <tr className="hover:bg-gray-50/50 transition-colors group" data-id="element-2844">
                        <td className="px-6 py-4" data-id="element-2845">
                          <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2846">
                            {scan.service}
                          </span>
                        </td>
                        <td className="px-6 py-4" data-id="element-2847">
                          <span className="text-[13px] text-gray-500" data-id="element-2848">
                            {scan.date}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-center" data-id="element-2849">
                          <span className={`text-[13px] font-bold ${scan.high > 0 ? 'text-red-600' : 'text-gray-400'}`} data-id="element-2850">
                            {scan.high}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-center" data-id="element-2851">
                          <span className={`text-[13px] font-bold ${scan.medium > 0 ? 'text-amber-600' : 'text-gray-400'}`} data-id="element-2852">
                            {scan.medium}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-center" data-id="element-2853">
                          <span className={`text-[13px] font-bold ${scan.low > 0 ? 'text-blue-600' : 'text-gray-400'}`} data-id="element-2854">
                            {scan.low}
                          </span>
                        </td>
                        <td className="px-6 py-4" data-id="element-2855">
                          {getStatusBadge(scan.status)}
                        </td>
                        <td className="px-6 py-4 text-right" data-id="element-2856">
                          <button className="text-[12px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-2857">
                            {scan.high > 0 || scan.medium > 0 ? 'Vedi Dettagli' : 'Report'}
                          </button>
                        </td>
                      </tr>
                      {/* Expanded row mock for one item to show findings pattern */}
                      {scan.id === 'sc2' && <tr className="bg-gray-50/30 border-b border-gray-100" data-id="element-2858">
                          <td colSpan={7} className="px-6 py-4" data-id="element-2859">
                            <div className="bg-white border border-red-100 rounded-lg p-4 shadow-sm" data-id="element-2860">
                              <h4 className="text-[12px] font-bold text-red-800 uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-2861">
                                <AlertCircle className="w-4 h-4" data-id="element-2862" /> Findings
                                Critici (1)
                              </h4>
                              <div className="flex flex-col gap-2" data-id="element-2863">
                                <div className="flex items-start gap-3 p-3 bg-red-50/50 rounded-md border border-red-100/50" data-id="element-2864">
                                  <div className="mt-0.5" data-id="element-2865">
                                    <FileText className="w-4 h-4 text-red-500" data-id="element-2866" />
                                  </div>
                                  <div data-id="element-2867">
                                    <p className="text-[13px] font-medium text-[#1A202C] font-mono" data-id="element-2868">
                                      src/services/resumeParser.ts{' '}
                                      <span className="text-gray-400 font-normal" data-id="element-2869">
                                        line 142
                                      </span>
                                    </p>
                                    <p className="text-[12px] text-gray-600 mt-1" data-id="element-2870">
                                      Dati biometrici (foto profilo) estratti e
                                      salvati in chiaro nel database senza
                                      cifratura a riposo.
                                    </p>
                                    <p className="text-[11px] text-red-600 font-medium mt-1" data-id="element-2871">
                                      Violazione GDPR Art. 32 - Sicurezza del
                                      trattamento
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>}
                    </Fragment>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>}

      {/* TAB 3: DPO & RESPONSABILI */}
      {activeTab === 'DPO & Responsabili' && <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2872">
          <div className="px-6 py-5 border-b border-gray-100 flex justify-between items-center" data-id="element-2873">
            <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2874">
              Governance per Servizio
            </h2>
            <div className="relative w-64" data-id="element-2875">
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-2876" />
              <input type="text" placeholder="Cerca servizio o persona..." className="w-full pl-9 pr-4 py-1.5 bg-gray-50 border border-gray-200 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8]" data-id="element-2877" />
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-2878">
            <table className="w-full text-left border-collapse" data-id="element-2879">
              <thead data-id="element-2880">
                <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-2881">
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2882">
                    Servizio
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2883">
                    DPO Assegnato
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2884">
                    Data Protection Contact
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2885">
                    Titolare Trattamento
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2886">
                    Ultimo Aggiornamento
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2887">
                    Azioni
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-2888">
                {DPO_DATA.map(item => <tr key={item.id} className="hover:bg-gray-50/50 transition-colors group" data-id="element-2889">
                    <td className="px-6 py-4" data-id="element-2890">
                      <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-2891">
                        {item.service}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-2892">
                      <div className="flex items-center gap-2" data-id="element-2893">
                        <div className="w-6 h-6 rounded-full bg-[#2A3B5C]/10 flex items-center justify-center text-[10px] font-bold text-[#2A3B5C]" data-id="element-2894">
                          {item.dpo.split(' ').map(n => n[0]).join('').replace('.', '')}
                        </div>
                        <span className="text-[13px] text-[#1A202C]" data-id="element-2895">
                          {item.dpo}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-2896">
                      <span className="text-[13px] text-gray-600" data-id="element-2897">
                        {item.contact}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-2898">
                      <span className="text-[13px] text-gray-600" data-id="element-2899">
                        {item.controller}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-2900">
                      <span className="text-[13px] text-gray-400" data-id="element-2901">
                        {item.updated}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2902">
                      <button className="p-1.5 text-gray-400 hover:text-[#00B4D8] hover:bg-blue-50 rounded-md transition-colors opacity-0 group-hover:opacity-100" data-id="element-2903">
                        <Edit2 className="w-4 h-4" data-id="element-2904" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {/* TAB 4: DATI SENSIBILI */}
      {activeTab === 'Dati Sensibili' && <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2905">
          <div className="px-6 py-5 border-b border-gray-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-2906">
            <div data-id="element-2907">
              <h2 className="text-[16px] font-semibold text-[#1A202C]" data-id="element-2908">
                Configurazione Dati Sensibili
              </h2>
              <p className="text-[12px] text-gray-500 mt-1" data-id="element-2909">
                Definisci i pattern che il sistema deve intercettare prima di
                inviare dati ai provider AI.
              </p>
            </div>
            <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-[#2A3B5C] text-white rounded-lg hover:bg-[#1E2A40] transition-colors shadow-sm text-[13px] font-medium whitespace-nowrap" data-id="element-2910">
              <Plus className="w-4 h-4" data-id="element-2911" />
              Aggiungi Tipo Dato
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-2912">
            <table className="w-full text-left border-collapse" data-id="element-2913">
              <thead data-id="element-2914">
                <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-2915">
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2916">
                    Nome
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2917">
                    Pattern (Regex)
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2918">
                    Severità
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2919">
                    Azione Default
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-center" data-id="element-2920">
                    Servizi Attivi
                  </th>
                  <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2921">
                    Stato
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-2922">
                {DATA_TYPES_DATA.map(type => <tr key={type.id} className={`hover:bg-gray-50/50 transition-colors ${!type.active ? 'opacity-60' : ''}`} data-id="element-2923">
                    <td className="px-6 py-4" data-id="element-2924">
                      <span className="text-[13px] font-medium text-[#1A202C]" data-id="element-2925">
                        {type.name}
                      </span>
                    </td>
                    <td className="px-6 py-4" data-id="element-2926">
                      <code className="text-[11px] bg-gray-100 text-gray-600 px-2 py-1 rounded font-mono border border-gray-200" data-id="element-2927">
                        {type.pattern}
                      </code>
                    </td>
                    <td className="px-6 py-4" data-id="element-2928">
                      {getSeverityBadge(type.severity)}
                    </td>
                    <td className="px-6 py-4" data-id="element-2929">{getActionBadge(type.action)}</td>
                    <td className="px-6 py-4 text-center" data-id="element-2930">
                      <span className="text-[13px] font-medium text-gray-600" data-id="element-2931">
                        {type.services}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2932">
                      {/* Simple Toggle Switch */}
                      <button className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none ${type.active ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-2933">
                        <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${type.active ? 'translate-x-4' : 'translate-x-1'}`} data-id="element-2934" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {/* INLINE MODAL: Aggiungi Tipo Dato */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-2935">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => setIsModalOpen(false)} data-id="element-2936"></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-2937">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-2938">
              <h2 className="text-[18px] font-semibold text-[#1A202C]" data-id="element-2939">
                Aggiungi Tipo Dato Sensibile
              </h2>
              <button onClick={() => setIsModalOpen(false)} className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2940">
                <X className="w-5 h-5" data-id="element-2941" />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-6 space-y-5" data-id="element-2942">
              <div data-id="element-2943">
                <label className="block text-[13px] font-medium text-gray-700 mb-1.5" data-id="element-2944">
                  Nome tipo dato *
                </label>
                <input type="text" placeholder="es. Numero Carta di Credito" value={newTypeName} onChange={e => setNewTypeName(e.target.value)} className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2945" />
              </div>

              <div data-id="element-2946">
                <label className="block text-[13px] font-medium text-gray-700 mb-1.5" data-id="element-2947">
                  Pattern (Regex) *
                </label>
                <input type="text" placeholder="es. ^(?:4[0-9]{12}(?:[0-9]{3})?)$" value={newTypePattern} onChange={e => setNewTypePattern(e.target.value)} className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-[13px] font-mono focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2948" />
                <p className="text-[11px] text-gray-500 mt-1.5" data-id="element-2949">
                  Il pattern regex utilizzato per intercettare il dato nel
                  payload.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-2950">
                <div data-id="element-2951">
                  <label className="block text-[13px] font-medium text-gray-700 mb-1.5" data-id="element-2952">
                    Severità
                  </label>
                  <select value={newTypeSeverity} onChange={e => setNewTypeSeverity(e.target.value)} className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2953">
                    <option value="Alta" data-id="element-2954">Alta</option>
                    <option value="Media" data-id="element-2955">Media</option>
                    <option value="Bassa" data-id="element-2956">Bassa</option>
                  </select>
                </div>
                <div data-id="element-2957">
                  <label className="block text-[13px] font-medium text-gray-700 mb-1.5" data-id="element-2958">
                    Azione Default
                  </label>
                  <select value={newTypeAction} onChange={e => setNewTypeAction(e.target.value)} className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8]" data-id="element-2959">
                    <option value="Blocca" data-id="element-2960">Blocca chiamata</option>
                    <option value="Maschera" data-id="element-2961">Maschera dato (***)</option>
                    <option value="Solo Log" data-id="element-2962">Solo Log</option>
                  </select>
                </div>
              </div>

              <div data-id="element-2963">
                <label className="block text-[13px] font-medium text-gray-700 mb-1.5" data-id="element-2964">
                  Descrizione
                </label>
                <textarea rows={3} placeholder="Descrizione opzionale dell'utilizzo..." value={newTypeDesc} onChange={e => setNewTypeDesc(e.target.value)} className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-[13px] focus:outline-none focus:border-[#00B4D8] focus:ring-1 focus:ring-[#00B4D8] resize-none" data-id="element-2965" />
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3" data-id="element-2966">
              <button onClick={() => setIsModalOpen(false)} className="px-4 py-2 text-[13px] font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm" data-id="element-2967">
                Annulla
              </button>
              <button onClick={() => setIsModalOpen(false)} className="px-4 py-2 text-[13px] font-medium text-white bg-[#2A3B5C] rounded-lg hover:bg-[#1E2A40] transition-colors shadow-sm" data-id="element-2968">
                Salva Tipo Dato
              </button>
            </div>
          </div>
        </div>}
    </div>;
}